import React from 'react'

const AddBedStatus = () => {
  return (
    <div>AddBedStatus</div>
  )
}

export default AddBedStatus